import { useCallback } from 'react'
import { useAppContext } from 'GlobalContext'
import { useRichiestaServerLogged } from "hook/useRichiestaServerLogged"

const URL_SERVER = process.env.REACT_APP_BE_URL

const ROTTA_BASE_API = URL_SERVER + 'be/api'

const OPERAZIONI = {
  CHIAVE_VERBALE: 'CHIAVE_VERBALE',
  CHIAVE_VERBALE_COOKIE: 'CHIAVE_VERBALE_COOKIE',
  PAGAMENTO_INIZIO: 'PAGAMENTO_INIZIO',
  PAGAMENTO_RITORNO: 'PAGAMENTO_RITORNO',
  LOGOUT_SPID: 'LOGOUT_SPID',
  SPID_AVVIO: 'SPID_AVVIO',
  CIE_CHECKSSO: 'CIE_CHECKSSO',
  INTERMEDIARI_GET: 'INTERMEDIARI_GET',
  SPID_AVVIO_CIE: 'SPID_AVVIO_CIE',
  INFO_COMANDO: 'INFO_COMANDO',
  VERBALI_DA_CF: 'VERBALI_DA_CF',
  INVIO_DATI_PATENTE: 'INVIO_DATI_PATENTE',
  UPLOAD_MODULO_CONDUCENTE: 'UPLOAD_MODULO_CONDUCENTE',
  RICERCA_CODICE_AVVISO: 'RICERCA_CODICE_AVVISO',
  DATI_VERBALE_EXTRA: 'DATI_VERBALE_EXTRA',
  CONFIGURAZIONE_GET: 'CONFIGURAZIONE_GET',
  CONFIGURAZIONE_NO_LANG_GET: 'CONFIGURAZIONE_NO_LANG_GET',
  CONFIGURAZIONE_SAVE: 'CONFIGURAZIONE_SAVE',
  CONFIGURAZIONE_FIELDS: 'CONFIGURAZIONE_FIELDS',
  TEST_CODICI_FISCALI: 'TEST_CODICI_FISCALI',
  TEST_COOKIE: 'TEST_COOKIE',
  PRATICHE_TOKEN: 'PRATICHE_TOKEN',

  PASS_DIZIONARI: 'PASS_DIZIONARI',
  PASS_SEARCH: 'PASS_SEARCH',
  PASS_GET: 'PASS_GET',
  PASS_GET_LISTA_TARGA: 'PASS_GET_LISTA_TARGA',
  PASS_UPDATE_TARGA: 'PASS_UPDATE_TARGA',
  PASS_UPDATE_SLOT: 'PASS_UPDATE_SLOT',

  STEP_INSERT: 'STEP_INSERT',
  STEP_GET: 'STEP_GET',
  TABELLA_DOMINIO: 'TABELLA_DOMINIO',
  COMUNE_CERCA: 'comune.cerca', // non cambiare, deve coincidere con il nome usato in OperazioniBase della base-ui
  TOKEN_VALIDATE: 'token.validate',
  CLEAR_CACHE: 'CLEAR_CACHE',
  NOMI_DB:'nomidb',
  READ_DB:'readDB'
}

const ENTITA = {

}

const rottaBaseApi = 'be/api/'

const OPERAZIONI_BASE_CONFIG = {
  [OPERAZIONI.CLEAR_CACHE]: {
    rottaBaseApi:'be/',
    endpoint: 'cache',
    httpMethod: 'get'
  },
  [OPERAZIONI.TOKEN_VALIDATE]: {
    rottaBaseApi,
    endpoint: 'tokenValidate',
    httpMethod: 'post'
  },
  [OPERAZIONI.CHIAVE_VERBALE]: {
    rottaBaseApi,
    endpoint: 'chiaveverbale/chiaveSingola',
    httpMethod: 'get'
  },
  [OPERAZIONI.CHIAVE_VERBALE_COOKIE]: {
    rottaBaseApi,
    endpoint: 'chiaveverbale/chiaveSingolaCookie',
    httpMethod: 'get'
  },
  [OPERAZIONI.PAGAMENTO_INIZIO]: {
    rottaBaseApi,
    endpoint: 'pagamento',
    httpMethod: 'post'
  },
  [OPERAZIONI.PAGAMENTO_RITORNO]: {
    rottaBaseApi,
    endpoint: 'pagamento/returnpagopa',
    httpMethod: 'post'
  },
  [OPERAZIONI.LOGOUT_SPID]: {
    rottaBaseApi,
    endpoint: 'spid/logout',
    httpMethod: 'post'
  },
  [OPERAZIONI.SPID_AVVIO]: {
    rottaBaseApi,
    endpoint: 'spid/avvio_spid',
    httpMethod: 'get'
  },
  [OPERAZIONI.CIE_CHECKSSO]: {
    rottaBaseApi,
    endpoint: 'cie/:intermediario/checkSso',
    httpMethod: 'get'
  },
  [OPERAZIONI.INTERMEDIARI_GET]: {
    rottaBaseApi,
    endpoint: 'spid/getIntermediari',
    httpMethod: 'get'
  },
  [OPERAZIONI.SPID_AVVIO_CIE]: {
    rottaBaseApi,
    endpoint: 'spid/avvio_cie',
    httpMethod: 'get'
  },
  [OPERAZIONI.INFO_COMANDO]: {
    rottaBaseApi,
    endpoint: 'comando/info',
    httpMethod: 'get'
  },
  [OPERAZIONI.VERBALI_DA_CF]: {
    rottaBaseApi,
    endpoint: 'chiaveverbale/chiavidacf',
    httpMethod: 'get'
  },
  [OPERAZIONI.INVIO_DATI_PATENTE]: {
    rottaBaseApi,
    endpoint: 'chiaveverbale/datiPatente',
    httpMethod: 'post'
  },
  [OPERAZIONI.UPLOAD_MODULO_CONDUCENTE]: {
    rottaBaseApi,
    endpoint: 'chiaveverbale/uploadModuloConducente',
    httpMethod: 'post'
  },
  [OPERAZIONI.RICERCA_CODICE_AVVISO]: {
    rottaBaseApi,
    endpoint: 'ricerca_codice_avviso',
    httpMethod: 'post'
  },
  [OPERAZIONI.DATI_VERBALE_EXTRA]: {
    rottaBaseApi,
    endpoint: 'datiVerbaleExtra',
    httpMethod: 'get'
  },
  [OPERAZIONI.CONFIGURAZIONE_GET]: {
    rottaBaseApi,
    endpoint: 'config/:cmd/:lingua/prefix/:chiave',
    httpMethod: 'get'
  },
  [OPERAZIONI.CONFIGURAZIONE_NO_LANG_GET]: {
    rottaBaseApi,
    endpoint: 'config/:cmd/prefix/:chiave',
    httpMethod: 'get'
  },
  [OPERAZIONI.CONFIGURAZIONE_SAVE]: {
    rottaBaseApi,
    endpoint: 'config/:cmd/set',
    httpMethod: 'post'
  },
  [OPERAZIONI.CONFIGURAZIONE_FIELDS]: {
    rottaBaseApi,
    endpoint: 'config/fields',
    httpMethod: 'post'
  },
  [OPERAZIONI.TEST_CODICI_FISCALI]: {
    rottaBaseApi,
    endpoint: 'test/codiciFiscali',
    httpMethod: 'get'
  },
  [OPERAZIONI.TEST_COOKIE]: {
    rottaBaseApi,
    endpoint: 'test/cookie',
    httpMethod: 'post'
  },
  [OPERAZIONI.PRATICHE_TOKEN]: {
    rottaBaseApi,
    endpoint: 'pratiche/:servizio/praticheToken',
    httpMethod: 'get'
  },

  [OPERAZIONI.PASS_DIZIONARI]: {
    rottaBaseApi,
    endpoint: 'pass/dizionari',
    httpMethod: 'post'
  },
  [OPERAZIONI.PASS_SEARCH]: {
    rottaBaseApi,
    endpoint: 'pass/search',
    httpMethod: 'get'
  },
  [OPERAZIONI.PASS_GET]: {
    rottaBaseApi,
    endpoint: 'pass/get',
    httpMethod: 'get'
  },
  [OPERAZIONI.PASS_GET_LISTA_TARGA]: {
    rottaBaseApi,
    endpoint: 'pass/getListaTarga',
    httpMethod: 'post'
  },
  [OPERAZIONI.PASS_UPDATE_TARGA]: {
    rottaBaseApi,
    endpoint: 'pass/updateTarga',
    httpMethod: 'post'
  },
  [OPERAZIONI.PASS_UPDATE_SLOT]: {
    rottaBaseApi,
    endpoint: 'pass/updateSlot',
    httpMethod: 'post'
  },

  [OPERAZIONI.STEP_INSERT]: {
    rottaBaseApi,
    endpoint: 'step/',
    httpMethod: 'post'
  },
  [OPERAZIONI.STEP_GET]: {
    rottaBaseApi,
    endpoint: 'step/',
    httpMethod: 'get'
  },
  [OPERAZIONI.TABELLA_DOMINIO]: {
    rottaBaseApi,
    endpoint: 'tabelleDominio/:tabella',
    httpMethod: 'get'
  },
  [OPERAZIONI.COMUNE_CERCA]: {
    rottaBaseApi,
    endpoint: 'comune/cerca',
    httpMethod: 'post'
  },
 [OPERAZIONI.NOMI_DB]: {
    rottaBaseApi,
    endpoint: 'read/nomiDb',
    httpMethod: 'get'
  },
  [OPERAZIONI.READ_DB]: {
    rottaBaseApi,
    endpoint: 'read/read',
    httpMethod: 'post'
  },
}

const ROTTA_BACK_PAGOPA = rottaBaseApi + 'pagamento/backPagoPA'

const SEPARATORE_UUID_ATTACHMENT = '@@@'

// La base-ui si aspetta un unico uuid per identificare un attachment da scaricare
// In questo caso il backend vuole 2 informazioni, quindi uso una funzione di appoggio 
// per creare un uuid temporaneo concatenando le informazioni con un separatore
function creaUuidPerAttachment(chiaveVerbale, idFile) {
  return [chiaveVerbale, idFile].join(SEPARATORE_UUID_ATTACHMENT)
}

// Funzione custom che gestisce l'uuid concatenato da creaUuidPerAttachment
function getAttachmentURLCustom({ uuid }) {
  const attachmentURL = new URL(`${window.location.origin}/${rottaBaseApi}scaricaAllegatoSingolo`)

  const [chiaveVerbale, idFile] = uuid.split(SEPARATORE_UUID_ATTACHMENT)
  const params = attachmentURL.searchParams
  params.append('chiave', chiaveVerbale)
  params.append('id', idFile)

  return attachmentURL.href
}

function useVerbali({ servizio }) {
  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer,
  } = useRichiestaServerLogged()

  const getVerbali = useCallback(
    () => inviaOperazione(OPERAZIONI.VERBALI_DA_CF, null, {}, { params: { servizio } }),
    [inviaOperazione, servizio]
  )

  return {
    getVerbali,
    inAttesaDelServer,
    ScatolaMessaggi,
  }
}

function useVerbale({ conCookie = false } = {}) {
  const { uri } = useAppContext()

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer,
  } = useRichiestaServerLogged()

  const operazione = conCookie ? OPERAZIONI.CHIAVE_VERBALE_COOKIE : OPERAZIONI.CHIAVE_VERBALE
  const getVerbale = useCallback(
    (chiaveVerbale) => inviaOperazione(operazione, null, {}, {
      params: { chiave: chiaveVerbale },
      headers: { uri }
    }),
    [inviaOperazione, operazione, uri]
  )

  return {
    getVerbale,
    inAttesaDelServer,
    ScatolaMessaggi,
  }
}

export {
  ROTTA_BASE_API,
  URL_SERVER,
  OPERAZIONI,
  ENTITA,
  OPERAZIONI_BASE_CONFIG,
  ROTTA_BACK_PAGOPA,
  creaUuidPerAttachment,
  getAttachmentURLCustom,
  useVerbale,
  useVerbali,
}